import * as cookies from "js-cookie"

export const clearSessionCookie = () => {
  cookies.remove("session")
  cookies.remove("connect.sid")
  cookies.remove("redirect")
}
